import { useContext, useEffect, useState } from 'react'
import MODsTemplateCard from '../Components/MODsTemplateCard'
import toast from 'react-hot-toast'
import axios from 'axios'
import { baseURL } from '../config'
import AuthContext from '../Context/AuthContext'
import LoadingAnimation from '../Components/LoadingAnimation'
import Searchbar from '../Components/Searchbar'
import useDebounce from '../hooks/useDebounce'
import { useNavigate } from 'react-router-dom'
import ButtonSolid from '../Components/ButtonSolid'

function MachineOrderTemplateList() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true);
    const [templateData, setTemplateData] = useState([]);
    const [refresh, setRefresh] = useState(false)
    const { token, logout } = useContext(AuthContext)
    const [modsSearch, setModsSearch] = useState('')
    const debouncedSearch = useDebounce(modsSearch)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                const response = await axios.get(`${baseURL}/template/getAllTemplates`,
                    {
                        headers: {
                            "ngrok-skip-browser-warning": "any",
                            "x-access-token": token
                        }, params: {
                            search: debouncedSearch
                        }
                    });
                if (response?.status === 204) {
                    setTemplateData('no data');
                } else {
                    setTemplateData(response.data.data.templateData)
                }
            } catch (error) {
                toast.error('Error:', error);
                logout();
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [refresh, debouncedSearch, logout, token]);

    if (templateData.length < 1 & loading === false) {
        return (
            <div className="py-3 md:py-6">
                <div className="w-full bg-white px-3 py-6 shadow-md rounded-lg">
                    <div className="text-center">
                        <h2 className="text-2xl font-medium mb-3">No MODs Templates Yet</h2>
                        <ButtonSolid
                            buttonText="Create MODs Template"
                            className="mx-auto"
                            onClick={() => navigate('/mods_template/add_mods_template')}
                        />
                    </div>
                    <div className="text-center mt-6 border-t pt-6">
                        <p className="text-gray-500 mb-3">Need to track individual equipment parts?</p>
                        <ButtonSolid
                            buttonText="Create Buyout"
                            onClick={() => navigate('/machine_orders/create_mods_data_sheet/buyout')}
                            className="!bg-blue-600 hover:!bg-blue-700 mx-auto"
                        />
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div>
            <div className='flex items-center justify-between flex-wrap pt-5 pb-2 gap-4'>
                <h3 className='font-semibold text-2xl mx-3'>Select MODs Template</h3>
                <div className='flex mx-3 gap-4 flex-wrap md:flex-nowrap'>
                    <Searchbar
                        value={modsSearch}
                        onChange={(e) => { setModsSearch(e.target.value) }}
                        disabled={loading}
                    />
                    <ButtonSolid
                        buttonText="Create Buyout"
                        onClick={() => navigate('/machine_orders/create_mods_data_sheet/buyout')}
                        className="!bg-blue-600 hover:!bg-blue-700 whitespace-nowrap"
                    />
                </div>
            </div>
            {loading ?
                (<div className='p-4'>
                    <LoadingAnimation />
                </div>) :
                (templateData === 'no data') ? <p className='px-2'>No templates available for '{debouncedSearch}'</p> :
                    (<div className='flex flex-wrap'>
                        {templateData?.map((data, index) => (
                            <MODsTemplateCard key={index} data={data} refresh={refresh} setRefresh={setRefresh} />
                        ))}
                    </div>)}
        </div>
    )
}

export default MachineOrderTemplateList

